import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Register French locale data
registerLocaleData(localeFr, 'fr-FR');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
